import {
  SET_FORM_DATA
} from './actionTypes'

export setFormData = (data) ->
  type: SET_FORM_DATA
  payload: { data }
